<template>
    <div class="avatar-field cursor-pointer">
        <img
            v-bind="$attrs"
            :src="finalImageSrc"
            loading="lazy"
            alt="Avatar" 
            @error="handleImageError"
        >
    </div>
</template>

<script>
import { branding } from '@/config/branding';

const STORAGE_KEY = 'whiz_broken_avatars';
const MAX_CACHE_SIZE = 300; // Limite máximo de URLs para guardar

// Carrega lista salva
let storedList = [];
try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) storedList = JSON.parse(raw);
} catch (e) {
    console.warn('Falha ao ler cache de avatares', e);
}

// Cria o Set global
const brokenUrls = new Set(storedList);

export default {            
    name: 'AvatarField',
    inheritAttrs: false,
    props: {  
        foto: {
            type: String,
            default: null 
        },
        isGroup: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            hasError: false
        }
    },
    watch: {
        // Se a prop mudar (troca de chat ou atualização de foto), reseta o erro
        foto(newVal) {
            this.hasError = false;
        }
    },
    computed: {
        finalImageSrc() {
            // Verifica na memória global se está bloqueada
            if (this.foto && brokenUrls.has(this.foto)) {
                return this.fallbackImage;
            }

            // Verifica erro local do componente atual
            if (this.hasError) {
                return this.fallbackImage;
            }

            //  Tenta exibir a imagem
            if (this.foto && this.foto.length > 5) {
                return this.foto;
            }

            return this.fallbackImage;
        },
        fallbackImage() {
            return this.isGroup ? branding.images.avatarFallbackGroup : branding.images.avatarFallback;
        }
    },
    methods: {
        handleImageError() {
            if (!this.foto) return;

            // Atualiza visualmente
            this.hasError = true;
            
            // Se já não estiver na lista, adiciona
            if (!brokenUrls.has(this.foto)) {
                brokenUrls.add(this.foto);

                //  LÓGICA DE LIMPEZA E SALVAMENTO 
                try {
                    // Converte para array
                    let arrayToSave = Array.from(brokenUrls);

                    // Se a lista estiver muito grande, remove os primeiros (mais antigos)
                    // Isso evita que o LocalStorage lote e permite que URLs antigas sejam retentadas um dia
                    if (arrayToSave.length > MAX_CACHE_SIZE) {
                        // Mantém apenas os últimos 300
                        arrayToSave = arrayToSave.slice(-MAX_CACHE_SIZE);
                        
                        // Atualiza o Set em memória para refletir o corte
                        brokenUrls.clear();
                        arrayToSave.forEach(url => brokenUrls.add(url));
                    }

                    localStorage.setItem(STORAGE_KEY, JSON.stringify(arrayToSave));
                } catch (e) {
                    // Silencia erro de cota
                }
            }
        }
    }     
}           
</script>

<style scoped>
img {
    border-radius: 50%;
    object-fit: cover;
    transition: opacity 0.2s ease-in-out;
}

.avatar-field img {
    width: 40px;
    height: 40px;
    background: var(--bs-sidebar-bg);
}
</style>